/* import __COLOCATED_TEMPLATE__ from './answers-provided.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();